const publicUrl = (process.env.PUBLIC_URL || "").replace(/\/$/, "");
const DEFAULT_ICON = `${publicUrl}/favicon.png`;

function removeFavicons(): void {
  document.head
    .querySelectorAll('link[rel="icon"], link[rel="shortcut icon"]')
    .forEach((el) => el.remove());
}

function addLink(href: string, type: string): void {
  const icon = document.createElement("link");
  icon.rel = "icon";
  icon.href = href;
  icon.type = type;
  document.head.appendChild(icon);
  const shortcut = document.createElement("link");
  shortcut.rel = "shortcut icon";
  shortcut.href = href;
  shortcut.type = type;
  document.head.appendChild(shortcut);
}

function bust(href: string): string {
  if (href.startsWith("data:")) return href;
  const sep = href.includes("?") ? "&" : "?";
  return `${href}${sep}_f=${Date.now()}`;
}

export function setDocumentFavicon(href: string, type = "image/png"): void {
  removeFavicons();
  addLink(bust(href), type);
}

export function resetDocumentFavicon(): void {
  removeFavicons();
  addLink(DEFAULT_ICON, "image/png");
}

function resolveCanvasColor(value: string | undefined, fallback: string): string {
  if (!value) return fallback;
  const v = String(value).trim();
  if (!v || v.startsWith("var(")) return fallback;
  return v;
}

export function letterFaviconDataUrl(
  name: string,
  bg: string | undefined,
  fg?: string
): string {
  const L = name.trim().slice(0, 1).toUpperCase() || "?";
  const size = 64;
  const canvas = document.createElement("canvas");
  canvas.width = size;
  canvas.height = size;
  const ctx = canvas.getContext("2d");
  if (!ctx) return DEFAULT_ICON;
  ctx.fillStyle = resolveCanvasColor(bg, "#2e7d32");
  ctx.beginPath();
  ctx.arc(size / 2, size / 2, size / 2, 0, Math.PI * 2);
  ctx.fill();
  ctx.fillStyle = resolveCanvasColor(fg, "#ffffff");
  ctx.font = `bold ${Math.floor(size * 0.45)}px system-ui, sans-serif`;
  ctx.textAlign = "center";
  ctx.textBaseline = "middle";
  ctx.fillText(L, size / 2, size / 2 + 1);
  return canvas.toDataURL("image/png");
}
